import { render, staticRenderFns } from "./OrganismGuidedTourTimeline.vue?vue&type=template&id=b40c0454&"
import script from "./OrganismGuidedTourTimeline.vue?vue&type=script&lang=js&"
export * from "./OrganismGuidedTourTimeline.vue?vue&type=script&lang=js&"
import style0 from "./OrganismGuidedTourTimeline.vue?vue&type=style&index=0&id=b40c0454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismGuidedTourTimeline.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fproject%2Fbuilding%2FOrganismGuidedTourTimeline.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingMoleculeGuidedTourTimeline: require('/app/components/molecules/project/building/MoleculeGuidedTourTimeline.vue').default})
